import { generateId } from 'src/utils/traceIdGenerations';
import { get, post } from './mainApi';
import axios from 'axios';

const leaveServiceBaseURL = process.env.REACT_APP_LEAVE_MANAGEMENT_SERVICE_V1_ENDPOINT;

export const getEvents = async (filter: { pageNo: number; pageSize: number; eventName:String; facilitator:String; date:String; }) => {
  const traceId = generateId(9);
  const response = post(`${leaveServiceBaseURL}event-management/event-details?traceId=${traceId}`, filter);
  return response;
};

export const getEventDetails = async (eventId, isPreview = false) => {
  const traceId = generateId(9);
  const response = get(`${leaveServiceBaseURL}event-management/event_details/${eventId}?isPreview=${isPreview}&traceId=${traceId}`);
  
  return response;
};

export const getAudiences = async () => {
  const traceId = generateId(9);
  const response = get(`${leaveServiceBaseURL}api/calendar/directory?traceId=${traceId}`);
  return response;
};

export const createEvent = async (body:any) => {
  const traceId = generateId(9);
  const response = post(`${leaveServiceBaseURL}event-management/event_create?traceId=${traceId}`,body);
  return response;
};

export const updateEvent = async (body:any) => {
  const traceId = generateId(9);
  const response = post(`${leaveServiceBaseURL}event-management/event_update?traceId=${traceId}`,body);
  return response;
};

export const deleteEvent = async (body:any) => {
  const traceId = generateId(9);
  const response = post(`${leaveServiceBaseURL}event-management/event_delete?traceId=${traceId}`,body);
  return response;
};

export const getAttendeeEvents = async (filter: {
  pageNo: number;
  pageSize: number;
  eventName: string;
  facilitator: string;
  date: string | null;
}) => {
  const traceId = generateId(9);
  return post(`${leaveServiceBaseURL}event-management/event-attendees?traceId=${traceId}`, filter);
};

export const fetchEventTemplate = async (body:any) => {
  const traceId = generateId(9);
  const response = post(`${leaveServiceBaseURL}event-management/event_template?traceId=${traceId}`,body);
  return response;
};